<template>
    <div class="printManagementDialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            v-if="dialogVisible"
            width="900px">
            <div class="dialogContent">
                <el-form :model="form" status-icon :rules="rules" ref="ruleForm" label-width="100px">
                    <el-form-item label="模型名称" prop="modelName">
                        <el-input v-model="form.modelName" placeholder="请输入模型名称"></el-input>
                    </el-form-item>
                    <el-form-item label="模型分类" prop="modelType">
                        <el-cascader
                            v-model="form.modelType"
                            :options="modelTypeList" style="width: 100%;" placeholder="请选择模型分类"></el-cascader>
                    </el-form-item>
                    <el-form-item label="模型封面" prop="modelBanner">
                        <div style="display: flex;">
                            <uploadImage
                                :buttonName="'模型封面'"
                                :img-file="form.modelBanner"
                                :width="'230'"
                                :height="'143'"
                                messSize='长需要为230px，宽需要为143px或长需要为230px,宽需要为373px的图片'
                                :imgsBtn="imgsBannerBtn"
                                @avatarChange="avatarChange($event,'ban')"
                                @getDragImgFile="getDragImgFile($event,'ban')"
                                @deleteImg="deleteImg($event,'ban')"
                            ></uploadImage>
                        </div>
                        <span style="color:#DCDFE6" >请上传长:230px,宽:143px或长:230px,宽:373px的图片</span>

                    </el-form-item>
                    <el-form-item label="模型图片" prop="imgList">
                        <div style="display: flex;">
                            <uploadImage
                                :buttonName="'上传图片'"
                                :img-file="form.imgList"
                                :width="'734'"
                                :height="'412'"
                                :imgType="'img'"
                                messSize='长需要为734px，宽需要为412px'
                                :imgsBtn="imgsBtn"
                                @avatarChange="avatarChange($event,'img')"
                                @getDragImgFile="getDragImgFile($event,'img')"
                                @deleteImg="deleteImg($event,'img')"
                            ></uploadImage>
                        </div>
                        <span style="color:#DCDFE6" >请上传长:734px,宽:412px的图片</span>
                    </el-form-item>
                    <el-form-item label="上传模型" prop="fileList">
                        <el-button type="primary"  @click="modelDialog('add')">添加</el-button>
                        <el-table
                            :data="form.fileList"
                            border
                            style="width: 100%;margin-top:20px">
                            <el-table-column
                                prop="url"
                                label="图片">
                                <template slot-scope="scope">
                                    <img :src="scope.row.url" alt="" style="width:100%">
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="模型">
                                <template slot-scope="scope">
                                    <p>{{scope.row.name}}</p>
                                </template>
                            </el-table-column>
                           <el-table-column
                                label="操作">
                                <template slot-scope="scope">
                                    <el-button @click="onClickDel(scope.$index)" type="text" size="small">删除</el-button>
                                    <el-button @click="modelDialog('edi',scope.$index)" type="text" size="small">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 因为校验不到，所以利用input来侧面验证 -->
                         <el-input
                            v-model="form.fileList"
                            style="display:none;"
                        ></el-input>
                        <ModelAddDialog ref="modelAddDialogRef" @tabDialogMess="tabDialogMess"/>
                    </el-form-item>
                    <el-form-item label="模型详情" prop="modelDes">
                        <vue-editor v-model="form.modelDes" useCustomImageHandler
                                    @image-added="handleImageAdded" style="width: 100%" />
                         <el-input
                            v-model="form.modelDes"
                            style="display:none;"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="模型描述" prop="remark">
                        <el-input type="textarea" :autosize="{ minRows: 6}" v-model="form.remark" placeholder="请输入模型详情"></el-input>
                    </el-form-item>
                    <el-form-item label="模型属性" prop="attribute">
                        <el-radio-group v-model="form.attribute">
                            <el-radio value="FREE" label="FREE">免费</el-radio>
                            <el-radio value="PAY" label="PAY">付费</el-radio>
                            <el-radio value="BROWSE" label="BROWSE">仅预览</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="form.attribute =='PAY'" label="模型价格" prop="price">
                        <el-input v-model="form.price" @blur="inputBlur" placeholder="请输入模型价格" style="width: 200px;"></el-input>
                        <span style="padding-left: 10px;">元</span>
                    </el-form-item>
                    <el-form-item label="SEO关键字" prop="metaKeywords">
                        <el-input type="textarea" :autosize="{ minRows: 3}" v-model="form.metaKeywords" placeholder="请输入SEO关键字"></el-input>
                    </el-form-item>
                    <el-form-item label="SEO描述" prop="metaDescription">
                        <el-input type="textarea" :autosize="{ minRows: 3}" v-model="form.metaDescription" placeholder="请输入SEO描述"></el-input>
                    </el-form-item>
                    <el-form-item prop="agreeRadio">
                        <el-checkbox v-model="form.agreeRadio" value="react">
                            <span>我已经阅读并同意</span>
                        </el-checkbox>
                        <span class="agreeMesg" @click="details">《{{dictionaryName}}》</span>
                    </el-form-item>

                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="save(false)">保存</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
                <el-dialog
                    width="30%"
                    :visible.sync="innerVisible"
                    append-to-body>
                    <div v-html="dictionaryRemarks" class="xieyiMsg"></div>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="innerVisible = false">我知道了</el-button>
                    </div>
                </el-dialog>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getModelList,
        addModelList,
        delModelList,
        getModelDetail,getDictionaryGroup,getDictionaryItem,uploadPicture,getDictionaryInfo
    } from "../../utils/interface";
    import uploadImage from '@/components/uploadImage'
    import uploadFile from '@/components/uploadFile'
    import ModelAddDialog from './modelAddDialog'

    // import fileUpload from '@/components/fileUpload'
    // import imgUpload from '@/components/imgUpload'
    export default {
        name: "materialManagementDialog",
        data() {
            return {
                dialogVisible: false,
                title: '',
                id: null,
                dictionaryName:'',
                dictionaryRemarks:'',
                form: {
                    modelName: '',
                    modelType: [],
                    price: 0,
                    remark: '',
                    imgList: [],
                    attribute: 'FREE',
                    fileList: [],
                    modelDes: '',
                    modelBanner:[],
                    agreeRadio:null,
                },
                rules: {
                    modelName: [
                        {required: true, message: '请输入模型名称', trigger: ['blur','change']}
                    ],
                    modelType: [
                        {required: true, message: '请选择模型分类', trigger: ['blur','change']}
                    ],
                    modelBanner: [
                        {required: true, message: '请上传模型封面',trigger: ['blur','change']}
                    ],
                    imgList: [
                        {required: true, message: '请上传模型图片',trigger: ['blur','change']}
                    ],
                    fileList: [
                        {required: true, message: '请上传模型文件',trigger: ['blur','change']}
                    ],
                    price:[
                        {required: true, validator: this.validatorNum,trigger: 'blur'}
                    ],
                    modelDes: [
                        {required: true, message: '请输入模型详情', trigger: ['blur','change']}
                    ],
                    remark: [
                        {required: true, message: '请输入模型描述', trigger: ['blur','change']}
                    ],
                    attribute: [
                        {required: true, message: '请选择模型属性', trigger: 'change'}
                    ],
                    metaKeywords:[
                        {max: 50, message: '最多允许输入50个汉字'}
                    ],
                    metaDescription:[
                        {max: 70, message: '最多允许输入70个汉字'}
                    ],
                    agreeRadio:[
                        {required: true, message: '请阅读并勾选', trigger: 'change'}
                    ],
                },
                modelTypeList: [],
                innerVisible: false,
                editorIndexClick: null, // 点击编辑的index
                imgsBtn: true,
                imgsBannerBtn: true,
                imgType:'img'
            }
        },
        components: {
            uploadImage,
            uploadFile,
            ModelAddDialog
            // fileUpload,
            // imgUpload
        },
        methods: {
            inputBlur(){
                if(this.form.price == 0){
                    this.form.price = null
                }
            },
            handleImageAdded(file, Editor, cursorLocation, resetUploader) {
                //formDta是个对象，用来模拟表单的
                let formData = new FormData()
                formData.append('file', file)
                uploadPicture(formData).then(response =>{
                    Editor.insertEmbed(cursorLocation, 'image', response.url)
                    resetUploader()
                })
            },
             // 题干富文本事件函数启动校验
                question () {
                // validateField表单的字段验证的方法
                this.$refs.form.validateField('modelDes')
                },
            // 删除
            onClickDel(index){
                this.$confirm('此操作将删除信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.fileList.splice(index, 1);
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            modelDialog(type,index){
                this.editorIndexClick = index
                this.$refs.modelAddDialogRef.init(type,this.form.fileList[index])
            },
            tabDialogMess(tabDialog ){
                if (tabDialog.dititle == "上传模型") {
                   this.form.fileList.push(tabDialog)
                } else {
                   this.form.fileList.splice(this.editorIndexClick, 1, tabDialog)
                }
            },

            init(type,id) {
                this.dialogVisible = true
                this.reset()
                getDictionaryGroup({ parentCode: "MODEL_CATEGORIES" }).then((res) => {
                    res.map((item) => {
                        item.value = item.uuid;
                        item.label = item.name;
                        getDictionaryItem({groupCode:item.code}).then((itemList)=>{
                            itemList.map((info)=>{
                                info.value = info.uuid;
                                info.label = info.name;
                            })
                            item.children = itemList;
                        })
                    });
                    this.modelTypeList = res;
                });
                if (type === 'add') {
                    this.title = '新增'
                    this.id = null
                    this.reset()
                    this.imgsBtn = true;
                    this.imgsBannerBtn = true;
                    this.form.attribute="FREE";
                } else {
                    this.title = '编辑'
                    this.id = id
                    this.getDetail(id)
                    if(this.form.modelBanner.length == 0){
                        this.imgsBannerBtn = true;
                    }else {
                        this.imgsBannerBtn = false;
                    }
                    if(this.form.imgList.length == 0){
                        this.imgsBtn = true;
                    }else {
                        this.imgsBtn = false;
                    }
                }
                getDictionaryInfo('MXSM').then((req)=>{
                    console.log(req)
                    this.dictionaryName = req.data.title;
                    this.dictionaryRemarks = req.data.content;
                })
            },
            submit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.save(true);
                    } else {
                        return false;
                    }
                });
            },
            save(isSubmit){
                this.form.status = isSubmit?"REVIEWING":"DRAFT";
                this.form.typeFirstUuid = this.form.modelType[0];
                this.form.typeSecondUuid = this.form.modelType[1];
                let imgs = [];
                if(this.form.imgList.length>0){
                    imgs.push({url:this.form.imgList[0].url, fileType: 'IMG', sort: 0});
                }
                if(this.form.modelBanner.length>0){
                    imgs.push({url:this.form.modelBanner[0].url, fileType: 'MAIN_IMG', sort: 1});
                }
                this.form.imgList = imgs;
                console.log(this.form)
                // this.loading = true
                addModelList({
                    uuid: this.id,
                    ...this.form
                }).then((res) => {
                    if (res.success) {
                        // this.alert(true, "success", "", true);
                        this.$alert((isSubmit?"提交":"保存")+"成功", "提示", {
                            confirmButtonText: "确定",
                            // callback: (action) => {
                            //     this.$message({
                            //         type: "info",
                            //         message: `提交成功`,
                            //     });
                            // },
                        });
                        this.reset();
                        this.$emit('submit');
                        this.dialogVisible = false;
                    }
                });
                // this.loading = false;

            },
            // 表单数字校验
            validatorNum(rule, value, callback){
                if (value === '') {
                    callback(new Error('请输入服务价格'))
                } else if (!/^\d+(\.\d+)?$/.test(value)) {
                    callback(new Error('请输入数字'))
                } else {
                    callback()
                }
            },
            // 上传成功
            avatarChange(val,type) {
                if(type == 'ban'){
                    this.form.modelBanner = val
                    this.$refs.ruleForm.validateField('modelBanner')
                    this.bannerImageListLength(val)
                }else if (type == 'img'){
                    this.form.imgList = val
                    this.$refs.ruleForm.validateField('imgList')
                    this.imageListLength(val)
                }
            },
            // 删除图片
            deleteImg(val,type) {
                if(type == 'ban'){
                    this.form.modelBanner = val
                    this.$refs.ruleForm.validateField('modelBanner')
                    this.bannerImageListLength(val)
                }else if (type == 'img'){
                    this.form.imgList = val
                    this.$refs.ruleForm.validateField('imgList')
                    this.imageListLength(val)
                }
            },
            // 获取拖拽后的图片
            getDragImgFile(file,type) {
                if(type == 'ban'){
                    this.form.modelBanner = file
                    this.$refs.ruleForm.validateField('modelBanner')
                    this.bannerImageListLength(file)
                }else if(type == 'img'){
                    if (file) {
                        this.form.imgList = file
                        this.$refs.ruleForm.validateField('imgList')
                        this.imageListLength(file)
                    }
                }
            },
            // 当前封面图片的个数
            bannerImageListLength(val){
                if (val.length > 0 ) {
                    this.imgsBannerBtn = false
                }else {
                    this.imgsBannerBtn = true
                }
            },
            // 当前模型图片的个数
            imageListLength(val){
                if (val.length > 0 ) {
                    this.imgsBtn = false
                }else {
                    this.imgsBtn = true
                }
            },
            reset() {
                this.form = {
                    modelName: '',
                    modelType: [],
                    price: 0,
                    remark: '',
                    imgList: [],
                    attribute: '',
                    fileList: [],
                    modelBanner: [],
                    metaDescription:'',
                    metaKeywords:'',
                }
                this.$nextTick(()=>{
                    if(this.$refs.ruleForm){
                        this.$refs.ruleForm.clearValidate()
                    }
                })
            },
            // 查询详情
            getDetail(id){
                // 获取详情接口
                getModelDetail({uuid:id}).then((res)=>{
                    this.reset();
                    this.form = res
                    this.form.imgList = [];
                    this.form.fileList = [];
                    this.form.modelBanner = [];
                    this.form.modelType = [];
                    this.form.modelType.push(res.typeFirstUuid);
                    this.form.modelType.push(res.typeSecondUuid);
                    for(let i in res.urlList){
                        let item = res.urlList[i];
                        if(item.fileType === "IMG"){
                            this.form.imgList.push(item);
                        }else if(item.fileType === "MAIN_IMG"){
                            this.form.modelBanner.push(item);
                        }else{
                            this.form.fileList.push(item);
                        }
                    }
                })
            },

            details(){
                this.innerVisible = true;
            }
        }
    }
</script>

<style scoped lang="less">
    .agreeMesg {
        color: #1890ff;
        cursor: pointer;
    }

    .dialogContent {
        padding: 0 5%;
        /deep/.el-upload-list--picture-card .el-upload-list__item{
            width: 80px;
            height: 80px;
        }
        /deep/.el-upload--picture-card{
            width: 80px;
            height: 80px;
            line-height: 80px;
        }
        /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
            width: 80px;
            height: 80px;
        }
        .thumbnailClass{
            width: 80px;
            height: 80px;
            margin-right: 20px;
            .avatar{
                width: 80px;
                height: 80px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 80px;
                font-size: 24px;
            }
        }
        .endPeriodClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
        .submitButtonClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }
        /*/deep/.el-form-item__label:before{*/
        /*    content: '*';*/
        /*    color: #F56C6C;*/
        /*    margin-right: 4px;*/
        /*}*/
        .detailsClass{
            /*/deep/.el-form-item__label{*/
            /*float: none;*/
            /*}*/
            /*/deep/.el-form-item__content{*/
            /*margin-left: 0 !important;*/
            /*}*/
        }
        .modelUpload{

          /deep/  .img-box{
                width: 90px!important;
                height: 90px!important;
               .avatar{
                    width: 90px!important;
                    height: 90px!important;
                }
            }
           /deep/ .drag-item{
                width: 240px;
                margin-left: 20px;

            }
        /deep/.avatar-uploader{

            text-align: center;
        }
        }
    }
    .xieyiMsg {
        margin: 0;
        font-size: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/views/production/modelManagementDialog.vue